const _excluded = ["isLabelHidden", "label", "required"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { Label, Stack } from 'office-ui-fabric-react';
import { useInput } from '../../../machines/inputMachine/useInput';
import { FieldErrorMessage } from '../../Validation/FieldErrorMessage';
import { SearchMultiDropdown } from '../../Search/SearchMultiDropdown';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const SearchMultiDropdownControl = props => {
  const {
      isLabelHidden,
      label,
      required
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const {
    name,
    value,
    errorMessage,
    send,
    touched
  } = useInput(props.inputService);
  const handleChange = newValue => {
    send([{
      type: 'FOCUS'
    }, {
      type: 'CHANGE',
      value: newValue
    }, {
      type: 'BLUR'
    }, {
      type: 'COMMIT'
    }]);
  };
  return /*#__PURE__*/_jsxs(Stack, {
    children: [!isLabelHidden && /*#__PURE__*/_jsx(Stack, {
      horizontal: true,
      horizontalAlign: "space-between",
      grow: true,
      children: /*#__PURE__*/_jsx(Stack.Item, {
        align: "start",
        children: /*#__PURE__*/_jsxs(Label, {
          disabled: props.disabled,
          children: [label !== null && label !== void 0 ? label : name, ' ', required && /*#__PURE__*/_jsx("span", {
            style: {
              color: 'rgb(164, 38, 44)'
            },
            children: "*"
          })]
        })
      })
    }), /*#__PURE__*/_jsx(SearchMultiDropdown, _objectSpread(_objectSpread({}, rest), {}, {
      value: value !== null && value !== void 0 ? value : [],
      onChange: handleChange,
      dataId: props.dataId
    })), errorMessage && touched && errorMessage.map((error, index) => error && /*#__PURE__*/_jsx(FieldErrorMessage, {
      children: error
    }, "error".concat(index)))]
  });
};